import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "../styles/theme.css";
import "../styles/Generate.css";
import RedTeamingPromptsTab from "./generate/RedTeamingPromptsTab";
import RedTeamingDocsTab from "./generate/RedTeamingDocsTab";
import RegulationCompliancePromptsTab from "./generate/RegulationCompliancePromptsTab";
import ConfidentialDocsTab from "./generate/ConfidentialDocsTab";

const TABS = [
  {
    id: "malicious-prompts",
    titleKey: "tabs.redTeamingPrompts.title",
    subtitleKey: "tabs.redTeamingPrompts.subtitle",
  },
  {
    id: "malicious-docs",
    titleKey: "tabs.redTeamingDocs.title",
    subtitleKey: "tabs.redTeamingDocs.subtitle",
  },
  {
    id: "regulation-compliance-prompts",
    titleKey: "tabs.regulationCompliancePrompts.title",
    subtitleKey: "tabs.regulationCompliancePrompts.subtitle",
  },
  // {
  //   id: "confidential-docs",
  //   titleKey: "tabs.confidentialDocs.title",
  //   subtitleKey: "tabs.confidentialDocs.subtitle",
  // },
];

function Generate() {
  const { t } = useTranslation("generate");
  const [activeTab, setActiveTab] = useState("malicious-prompts");

  return (
    <div className="theme-whbl">
      <Header />
      <div className="main-container" style={{ minHeight: "100vh" }}>
        <div style={{ height: "100vh" }}>
          <Sidebar />
        </div>
        <div className="main-content" style={{ flex: 1, padding: "20px", minHeight: "100vh" }}>
          <div className="generate-page-container">
            <div className="generate-tab-container">
              {TABS.map((tab) => (
                <div
                  key={tab.id}
                  role="button"
                  tabIndex={0}
                  onClick={() => setActiveTab(tab.id)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setActiveTab(tab.id);
                    }
                  }}
                  className={`generate-tab-button ${activeTab === tab.id ? "active" : ""}`}
                >
                  <div className="generate-tab-content">
                    <div className="generate-tab-title">{t(tab.titleKey)}</div>
                    <div className="generate-tab-subtitle">{t(tab.subtitleKey)}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="generate-content-wrapper">
              <div className="generate-content">
                <aside className="generate-legal-notice" role="note">
                  <strong className="generate-legal-notice-label">{t("legalNotice.label")}</strong>{" "}
                  {t("legalNotice.text")}
                </aside>

                {activeTab === "malicious-prompts" && <RedTeamingPromptsTab />}
                {activeTab === "malicious-docs" && <RedTeamingDocsTab />}
                {activeTab === "regulation-compliance-prompts" && <RegulationCompliancePromptsTab />}
                {activeTab === "confidential-docs" && <ConfidentialDocsTab />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Generate;
